import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router';
// 引入NavigationDuplicated错误
import { NavigationDuplicated } from 'vue-router';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/quill/quill.core.css';
import '@/assets/quill/quill.snow.css';
import '@/assets/quill/quill.bubble.css';
import './index.css'
import DetailedPage from '../src/components/DetilsPage/index.vue'
import NavTop from '../src/components/comcomponents/NavTop.vue'
import Swiper from '../src/components/swiper/swiper.vue'
import {extractDate, extractDateList, extractDateTime} from '../src/utils/time.js';
import VueAMap from 'vue-amap'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css' // 确保引入正确的CSS文件路径

// 保存原始的push方法
const originalPush = VueRouter.prototype.push;
// 修改push方法，增加错误处理
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location)
    .then(() => {
      // 导航成功
    })
    .catch(err => {
      window.location.reload();
    });
};
Vue.prototype.$extractDate = extractDate
Vue.prototype.$extractDateList = extractDateList
Vue.prototype.$extractDateTime = extractDateTime
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.component('DetailedPage', DetailedPage)
Vue.component('NavTop', NavTop)
Vue.component('Swiper', Swiper)
Vue.use(VueRouter);
Vue.use(ElementUI)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'ef3de55fc51c2bfd2ac3e917e8891131', // 替换为你的API Key
  plugin: ['AMap.Geolocation'] // 需要使用的插件列表
})
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js